const config = {
  breakpoints: {
    navCollapse: 500
  }
};

export default config;
